<!--
 * @Date: 2024-05-07 15:21:41
 * @LastEditTime: 2024-06-06 11:46:57
-->
<template>
  <div>
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="goToPage"
      :rightIcons="false"
    >
    </Header>
    <div style="margin-top: 20px">
      <van-form style="width: 100%" ref="form" validate-trigger="onChange">
        <van-cell-group inset>
          <van-field
            name="yotei_name"
            v-model="scheduleDetail.yotei_name"
            rows="2"
            autosize
            label="会議名:"
            :rules="[{ required: true, message: '会議名を入力してください' }]"
            type="textarea"
            maxlength="20"
            placeholder="会議名を入力してください"
            show-word-limit
          />
          <van-field
            v-model="scheduleDetail.memo"
            rows="2"
            autosize
            label="備考:"
            type="textarea"
            maxlength="100"
            placeholder="備考を入力してください"
            show-word-limit
          />
          <van-field
            readonly
            label-width="8rem"
            v-model="scheduleDetail.yotei_start_time"
            input-align="right"
            label="開始時刻:"
            :rules="[
              {
                required: true,
                message: '選択してください',
              },
              // 如果是copy会议需要验证时间是否超过当前时间
              {
                message: '開始時刻は過去の時間を選択できません',
                validator: isVerifyStartTime,
              },
              {
                name: 'yotei_start_time',
                message: '開始時刻は終了時刻より遅くすることはできません',
                validator: isVerifyDateRange,
              },
            ]"
            name="yotei_start_time"
            @click="onShowDatePicker(true)"
          />

          <van-field
            readonly
            clickable
            label-width="8rem"
            v-model="scheduleDetail.yotei_end_time"
            placeholder="選択してください"
            :rules="[
              {
                required: true,
                message: '選択してください',
              },
              {
                name: 'yotei_end_time',
                message: '終了時刻は開始時刻より早くすることはできません',
                validator: isVerifyDateRange,
              },
            ]"
            name="yotei_end_time"
            @click="onShowDatePicker(false)"
            input-align="right"
            label="終了時刻:"
          />
          <!-- 当是通过room一览界面过来新增 则直接显示并禁用  -->
          <van-field
            readonly
            :disabled="query.roomId"
            clickable
            label="ルーム:"
            name="room_name"
            v-model="scheduleDetail.room_name"
            rows="1"
            autosize
            type="textarea"
            placeholder="選択してください"
            :rules="[{ required: true, message: 'ルーム入力してください' }]"
            label-width="8rem"
            @click="
              () => {
                if (!(query.roomId && !query.roomyoteiId)) {
                  isSelectRooms = true;
                }
              }
            "
            input-align="right"
          />

          <van-field
            readonly
            clickable
            label="参加者:"
            name="attendUserNames"
            v-model="attendUserNames"
            rows="1"
            autosize
            type="textarea"
            placeholder="選択してください"
            label-width="8rem"
            :rules="[{ required: true, message: '参加者入力してください' }]"
            @click="onSelectMorePopup('join_docotor_ids')"
            input-align="right"
          />
          <van-field
            readonly
            clickable
            label="アプリプッシュ通知:"
            v-model="appUserNames"
            rows="1"
            autosize
            type="textarea"
            placeholder="選択してください"
            label-width="8rem"
            @click="onSelectMorePopup('app_remind_users')"
            input-align="right"
          />
          <van-field
            readonly
            clickable
            label="メール通知:"
            v-model="mailUserNames"
            rows="1"
            autosize
            type="textarea"
            placeholder="選択してください"
            label-width="8rem"
            @click="onSelectMorePopup('mail_remind_users')"
            input-align="right"
          />
        </van-cell-group>
        <section style="width: 80%; margin: 16px auto">
          <van-button
            style="width: 100%"
            round
            size="large"
            @click="onSave"
            color="#3B82C4"
          >
            {{
              !!query.roomyoteiId ? "変更を保存する" : "予約を追加する"
            }}</van-button
          >
        </section>
      </van-form>
    </div>
  </div>
  <van-popup
    v-model:show="isDatePicker"
    position="bottom"
    style="max-height: 35%"
  >
    <div class="popnuBtn">
      <div @click="isDatePicker = false">キャンセル</div>
      <div @click="onConfirmDate">確認</div>
    </div>
    <van-datetime-picker
      :show-toolbar="false"
      v-model="selectDate"
      type="datetime"
      :filter="dateFilter"
    />
  </van-popup>
  <van-popup
    v-model:show="isSelectRooms"
    position="bottom"
    style="max-height: 35%"
    :close-on-click-overlay ="false"
  >
    <div class="popnuBtn">
      <div @click="onCloseSelectRooms">キャンセル</div>
      <div @click="onCloseSelectRooms">確認</div>
    </div>
    <van-radio-group v-model="scheduleDetail.room_id">
      <van-cell-group>
        <van-cell
          v-for="room in rooms"
          clickable
          :key="room.id"
          :title="room.name"
          @click="onSelectRoom(room)"
        >
          <template #right-icon>
            <van-radio :name="room.room_id" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
  </van-popup>
  <van-popup
    v-model:show="isSelectMore"
    position="bottom"
    style="max-height: 35%"
  >
    <div class="popnuBtn">
      <div @click="isSelectMore = false">キャンセル</div>
      <div @click="onSelectMore">確認</div>
    </div>
    <van-checkbox-group v-model="values">
      <van-cell-group>
        <van-cell
          v-for="(doctor, index) in doctors"
          clickable
          :key="doctor.doctor_id"
          :title="doctor.name"
          @click="doctorRefs[doctor.doctor_id].toggle()"
        >
          <template #right-icon>
            <van-checkbox
              shape="square"
              :name="doctor.doctor_id"
              :ref="(el) => (doctorRefs[doctor.doctor_id] = el)"
              @click.stop
            />
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
  </van-popup>

  <van-overlay :show="isOverlay" class="center">
    <van-loading class="center" type="spinner" color="#1989fa" />
  </van-overlay>
</template>

<script>
let backPath = "";
export default {
  beforeRouteEnter(to, from, next) {
    backPath = from.fullPath;
    next();
  },
};
</script>
<script setup>
import { Dialog, Toast } from "vant";
import moment from "moment";
import "vant/es/toast/style";
import Header from "@/components/Header.vue";
import { SaveYotei, GetScheduls, GetRooms ,GetDoctorsByRoom} from "@/services/room.js";
import { pushScheduleMessage } from "@/services/pushmessage";
import { computed, onMounted, ref, reactive, watch, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import { cloneDeep } from "@/utils/utils";

const router = useRouter();
const { query } = useRoute();

const isDatePicker = ref(false);
const selectDate = ref(null);
const isStartTime = ref(false);
const scheduleDetail = reactive({
  room_name: "",
  yotei_name: "",
  memo: "",
  yotei_start_time: query?.yoteiStartTime
    ? query?.yoteiStartTime
    : moment().format("YYYY-MM-DD HH:mm"),
  yotei_end_time: "",
  room_id: "",
  join_docotor_ids: "",
  app_remind_users: "",
  mail_remind_users: "",
  yotei_members: "",
});
const doctors = ref();
const rooms = ref();
const isSelectRooms = ref(false);
const isSelectMore = ref(false);
const doctorRefs = ref([]);
const values = ref();
const bindName = ref();
const appUserNames = ref();
const attendUserNames = ref();
const mailUserNames = ref();
const isOverlay = ref(true);
const form = ref(null);

const goToPage = () => {
  // router.push({
  //   path: backPath || "/",
  //   query,
  // });
  history.back();
};

const getscheduleDetail = async () => {
  try {
    // 修改或者复制会议则请求该条会议 复制会议不需要id和roomyotei_id只填充数据
    if (query.roomyoteiId || query.copyRoomyoteiId) {
      const {
        data: {
          data: [schedule],
        },
      } = await GetScheduls({
        roomyotei_id: query.roomyoteiId || query.copyRoomyoteiId,
      });

      // 如果是复制会议需要删除id和roomyotei_id
      Object.assign(
        scheduleDetail,
        query.copyRoomyoteiId
          ? cloneDeep(schedule, "id", "roomyotei_id")
          : schedule
      );
    } else {
      if (query.roomName && query.roomId) {
        Object.assign(scheduleDetail, {
          room_id: query.roomId,
          room_name: query.roomName,
        });
      }
    }
  } catch (error) {
    console.error(error);
  }
};

const getDoctors = async (room_id) => {
  try {
    let res = await GetDoctorsByRoom({room_id:room_id});
    if (res.data.code >= 0) {
      doctors.value = res.data.data;
      const { attendNames, appNames, mailNames } = formatDoctor(
          scheduleDetail.join_docotor_ids,
          scheduleDetail.app_remind_users,
          scheduleDetail.mail_remind_users
      );
      attendUserNames.value = attendNames.join(",");
      appUserNames.value = appNames.join(",");
      mailUserNames.value = mailNames.join(",");
    }else{
      Toast.fail("エラーが発生しました");
    }
    return;
  } catch (error) {
    console.error(error);
  }
};

const getRooms = async () => {
  try {
    const {
      data: { data: roomsData },
    } = await GetRooms();
    if (!roomsData.length) {
      await Dialog.alert({
        message: "会議室が空なので追加してください",
      });
      router.push({
        path: "/roomCalendar",
      });
    }
    rooms.value = roomsData;
  } catch (error) {
    console.error(error);
  }
};

onMounted(async () => {
  isOverlay.value = true;
  try {
    await getscheduleDetail();
    // await getDoctors();
    await getRooms();
    if(query.roomId){
      getDoctors(query.roomId);
    }
    if (query.copyRoomyoteiId) {
      nextTick(async () => {
        await form.value.validate(["yotei_start_time", "yotei_end_time"]);
      });
    }
  } catch (error) {
    console.error(error);
  } finally {
    isOverlay.value = false;
  }
});

const onShowDatePicker = async (isStart) => {
  isStartTime.value = isStart;
  isDatePicker.value = true;

  setTimeout(() => {
    selectDate.value = isStart
      ? scheduleDetail?.yotei_start_time
        ? moment(scheduleDetail?.yotei_start_time).toDate()
        : moment(scheduleDetail.yotei_end_time).subtract(15, "minutes").toDate()
      : scheduleDetail?.yotei_end_time
      ? moment(scheduleDetail?.yotei_end_time).toDate()
      : moment(scheduleDetail.yotei_start_time).add(15, "minutes").toDate();
  }, 0);
};
const onConfirmDate = () => {
  if (isStartTime.value) {
    scheduleDetail.yotei_start_time = moment(selectDate.value).format(
      "YYYY-MM-DD HH:mm"
    );
  } else {
    scheduleDetail.yotei_end_time = moment(selectDate.value).format(
      "YYYY-MM-DD HH:mm"
    );
  }
  form.value.validate([
    isStartTime.value ? "yotei_end_time" : "yotei_start_time",
  ]);

  isDatePicker.value = false;
};

const dateRange = computed(() => {
  return {
    minDate: isStartTime.value
      ? query?.copyRoomyoteiId || query?.roomyoteiId
        ? moment("2014-01-01").toDate()
        : moment().toDate()
      : scheduleDetail.yotei_start_time
      ? moment(scheduleDetail.yotei_start_time).add(15, "minutes").toDate()
      : new Date(),
    maxDate: isStartTime.value
      ? scheduleDetail.yotei_end_time
        ? moment(scheduleDetail.yotei_end_time).subtract(15, "minutes").toDate()
        : new Date(new Date().getFullYear() + 5, 12, 31)
      : new Date(new Date().getFullYear() + 5, 12, 31),
  };
});

const dateFilter = (type, options) => {
  if (type === "minute") {
    return options.filter((option) => option % 5 === 0);
  }
  return options;
};

const onSelectRoom = (room) => {
  scheduleDetail.room_name = room.name;
  scheduleDetail.room_id = room.room_id;
};

const onCloseSelectRooms = ()=>{
  // 关闭弹窗
  isSelectRooms.value = false;
  // 清空之前选择的值
  scheduleDetail.join_docotor_ids = "";
  scheduleDetail.app_remind_users = "";
  scheduleDetail.mail_remind_users = "";
  if(scheduleDetail.room_id){
    getDoctors(scheduleDetail.room_id);
  }
}

const onSelectMorePopup = (rName) => {
  console.log(scheduleDetail);
  if(!scheduleDetail.room_id){
    // 需要先选择room
    Toast.fail("ルームを選んでください。");
    return;
  }
  values.value = scheduleDetail[rName] ? scheduleDetail[rName].split(",") : [];
  bindName.value = rName;
  isSelectMore.value = true;
};

const onSelectMore = () => {
  scheduleDetail[bindName.value] = values.value.join(",");
  isSelectMore.value = false;
};
watch(
  () => [
    scheduleDetail.join_docotor_ids,
    scheduleDetail.app_remind_users,
    scheduleDetail.mail_remind_users,
  ],
  ([joinDoctors, appDoctors, mailDoctors]) => {
    if (doctors.value?.length) {
      const { attendNames, appNames, mailNames } = formatDoctor(
        joinDoctors,
        appDoctors,
        mailDoctors
      );
      attendUserNames.value = attendNames.join(",");
      appUserNames.value = appNames.join(",");
      mailUserNames.value = mailNames.join(",");
    }
  }

);

const formatDoctor = (joinDoctors, appDoctors, mailDoctors) => {
  return doctors.value.reduce(
    (names, { doctor_id, name }) => {
      if (joinDoctors && joinDoctors.includes(doctor_id)) {
        names?.attendNames.push(name);
      }
      if (appDoctors && appDoctors.includes(doctor_id)) {
        names?.appNames.push(name);
      }
      if (mailDoctors && mailDoctors.includes(doctor_id)) {
        names?.mailNames.push(name);
      }
      return names;
    },
    {
      attendNames: [],
      appNames: [],
      mailNames: [],
    }
  );
};

const isVerifyStartTime = (value) => {
  if (!query.roomyoteiId) {
    if (moment(value).isBefore(moment())) {
      return false;
    }
  }

  return true;
};

const isVerifyDateRange = async (value, { name }) => {
  // 验证时间区间是否正确
  if (name === "yotei_start_time" && scheduleDetail?.yotei_end_time) {
    return moment(value).isBefore(moment(scheduleDetail?.yotei_end_time));
  } else if (name === "yotei_end_time" && scheduleDetail?.yotei_start_time) {
    return moment(value).isAfter(moment(scheduleDetail?.yotei_start_time));
  }
  return true;
};

const onSave = async () => {
  try {
    await form.value.validate();
    const roomId = rooms.value.find((r) => r.room_id === scheduleDetail.room_id)?.id
    let roomyotei_url = `/#/beforeRoom?savePathFlg=1&id=${roomId}&room_id=${scheduleDetail.room_id}`;
    let host = location?.host;
    switch (true) {
      // 旧的测试环境
      case host?.includes("demo-app"):
        roomyotei_url = "https://ios-webrtc-tmp.demo-app.jp" + roomyotei_url;
        break;
      // 新的测试环境
      case host?.includes("stg"):
        roomyotei_url = "https://stg-ios-dashboard.qualink.jp" + roomyotei_url;
        break;
      // 本地环境
      case host?.includes("localhost") || host?.includes("127.0.0.1"):
        roomyotei_url = `http://${host}` + roomyotei_url;
        break;
      //新的本番-测试
      case host?.includes("prod"):
        roomyotei_url = `https://${host}` + roomyotei_url;
        break;
      // 正式环境
      case !!host:
        roomyotei_url = "https://web-dashboard.qualink.jp" + roomyotei_url;
    }
    const detail = {
      id: scheduleDetail.id,
      roomyotei_id: scheduleDetail.roomyotei_id,
      yotei_name: scheduleDetail.yotei_name,
      memo: scheduleDetail.memo,
      yotei_start_time: scheduleDetail.yotei_start_time,
      yotei_end_time: scheduleDetail.yotei_end_time,
      room_id: scheduleDetail.room_id,
      join_docotor_ids: scheduleDetail.join_docotor_ids,
      app_remind_users: scheduleDetail.app_remind_users,
      mail_remind_users: scheduleDetail.mail_remind_users,
      roomyotei_url,
    };
    const {
      data: { data, code },
    } = await SaveYotei({
      detail,
    });
    if (code && code === 1001) {
      Toast.fail("指定された時間帯はご利用いただけません。");
      return;
    }
    // 选择的会议室被删除
    if (code && code === 410) {
      Toast.fail(data);
      await getRooms();
      scheduleDetail.room_id = "";
      scheduleDetail.room_name = "";
      return;
    }
    if (code >= 0) {
      pushScheduleMessage({
        app_remind_users: detail.app_remind_users, //app push
        mail_remind_users: detail.mail_remind_users, //mail push
        yotei_name: detail.yotei_name, //会议名
        yotei_start_time: detail.yotei_start_time,
        yotei_end_time: detail.yotei_end_time,
        room_id: detail.room_id,
        room_name: scheduleDetail.room_name,
        memo: scheduleDetail.memo,
        join_doctors: attendUserNames.value,
        id: roomId, //room id 唯一键
        roomyotei_url,
      });
      Toast.success("追加に成功しました。");
      goToPage();
    }
  } catch (error) {
    console.error(error);
    Toast.fail("追加に失敗しました。");
  }
};
</script>

<style lang="less" scoped>
.popnuBtn {
  /* 将按钮黏贴在顶部 */
  position: sticky;
  top: 0px;
  display: flex;
  justify-content: space-between;
  background-color: rgb(252, 252, 252);
  font-size: 18px;
  font-weight: bold;
  z-index: 3;

  & div {
    padding: 10px;
  }
  :first-child {
    color: rgb(244, 39, 23);
  }
  :nth-child(2) {
    color: rgb(59, 130, 196);
  }
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .van-field__error-message {
  text-align: right;
}
</style>
